/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DeleteAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Confirmation from './Confirmation/index'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function DeleteAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Procedures/ActionsAction/Content/Content/DeleteAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="ghost"
 block={true}
 justifyContent="flex-start"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Confirmation/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Confirmation/Content'))}
 text="Delete procedures"
/>
<Confirmation
  viewPath={`${viewPath}/Confirmation`}
/>
{children}
</React.Fragment>)
}